export function StaticVariables() {
  const TITLE = "Search Bubble.";
  const BACK_BTN = "&#10140;";
  const MIN_RANGE = 5;
  const AUTH_LOGIN_TEXT = "Don't have a Search Bubble account?";
  const AUTH_LOGIN_LINK = "Create one!";
  const AUTH_SIGNUP_TEXT = "Already have a Search Bubble account?";
  const AUTH_SIGNUP_LINK = "Log in!";
  const AUTH_TERMS_TEXT =
    "By continuing, you agree to Search Bubbles's Terms of Service and Privacy Policy, and to receive periodic emails with updates.";
  const AUTH_TERMS_LINK = "Read the terms";
  const AUTH_LOGIN_HEADING = "Welcome back";
  const AUTH_LOGIN_MSG = "Sign in to your account";
  const AUTH_SIGNUP_HEADING = "Get started";
  const AUTH_SIGNUP_MSG = "Create a new account";
  const ACCOUNT_TITLE = "Account";
  const BILLING_TITLE = "Billing";
  const CONTENT_TITLE = "Content Bank";
  const ANALYTICS_TITLE = "Analytics";
  const PLATFORMS_INTEGRATION_TITLE = "Connected Platforms";
  const MANAGE_ALL_LINKS_TITLE = "All Links";
  const MANAGE_STAYUPTODATE_TITLE = "Stay Up To Date";
  const MANAGE_LANDING_TITLE = "Landing";
  const PRODUCT_BANK = "Product Bank";
  const TUTORIALS_TITLE = "Tutorials";

  const OVERVIEW_HEADING = "Overview";
  const SEARCH_ORIGINATING_HEADING = "Searches Originating From";
  const CONTROLS_TITLE = "Controls";
  const STAGING_CONTROLS_TITLE = "Staging View";
  const ACTIVE_FEED_MSG =
    "Active content, if relevant, will be shown in search results while Archived content will never be shown in search results.";
  const ARCHIVE_FEED_MSG =
    "There are no Archived posts. All pieces of content are currently marked as Active which means they will show up in search results, if relevant.";
  const HOMEPAGE_IMAGES = [
    "https://nneqehyphaavozzymtwp.supabase.co/storage/v1/object/public/profile-picture/338441889_767732654637846_1626502643083092314_n.jpeg",
    "https://nneqehyphaavozzymtwp.supabase.co/storage/v1/object/public/homepage-images/Marvin-Jacob.jpg?t=2023-05-04T06%3A43%3A55.474Z",
    "https://nneqehyphaavozzymtwp.supabase.co/storage/v1/object/public/homepage-images/Lindsey-Huffman.jpg?t=2023-05-04T06%3A47%3A31.143Z",
    "https://nneqehyphaavozzymtwp.supabase.co/storage/v1/object/public/homepage-images/jayalekshman-sj-EbSUug_7kMI-unsplash.jpg?t=2023-05-04T06%3A51%3A58.929Z",
    "https://nneqehyphaavozzymtwp.supabase.co/storage/v1/object/public/profile-picture/354413476_962947541602179_8692387845536302535_n.jpeg",
    "https://nneqehyphaavozzymtwp.supabase.co/storage/v1/object/public/homepage-images/Johnny-Kyunghwo.jpg?t=2023-05-04T06%3A52%3A35.530Z",
    "https://nneqehyphaavozzymtwp.supabase.co/storage/v1/object/public/profile-picture/thebluewallstudio.jpeg",
  ];
  const SIGNING_UP_TEXTS = [
    "Setting up your account!",
    "Getting your Search SBubble account ready!",
    "Fetching data from Instagram!",
    "Finishing up!",
  ];
  const ROUTELIST_ITEMS = [
    "Account",
    "Tutorials",
    "Analytics",
    "Connected Platforms",
    "Controls",
    "Content Bank",
    // "All Links",
    "Landing Page",
    "Product Bank",
    "Embed Page"
  ];

  const SEARCH_EXCEPTIONS = ["rings", "earrings", "dress", "dresses"];
  const instagram_CONTROLS = [
    "Show Top Hashtags",
    "Show Instagram Highlights",
    "Number of Top Hashtags",
  ];
  const TYPES = [
    "FEED",
    "REELS",
    "STORY",
    "HIGHLIGHTS",
    "PIN",
    "VIDEO",
    "PODCAST",
    "TIKTOK",
    "MAIL",
    "TWEET",
    "PRODUCT",
    "POST",

    // "COMMENT"
  ];
  const PLATFORMS = [
    "instagram",
    "youtube",
    "tiktok",
    "podcast",
    "pinterest",
    "newsletter",
    "twitter",
    "LTK",
    "Amazon",
    "ShopMy",
    "MISC",
    "linkedin",

    "MISC-content",
    // "instaComment"
    ,
  ];

  const CONTENT_PLATFORMS = [
    "instagram",
    "youtube",
    "tiktok",
    "podcast",
    "pinterest",
    "newsletter",
    "twitter",
    "linkedin",
    // "instaComment"
    "MISC-content",
  ];
  const PRODUCT_PLATFORMS = ["LTK", "ShopMy", "Amazon", "MISC"];
  const youtube_CONTROLS: any = [];
  const newsletter_CONTROLS: any = [];
  const podcast_CONTROLS: any = [];
  const tiktok_CONTROLS: any = [];
  const pinterest_CONTROLS: any = [];

  const instagram_ANALYTICS = ["Instagram Highlights", "Top Hashtags"];
  const youtube_ANALYTICS: any = [];
  const newsletter_ANALYTICS: any = [];
  const podcast_ANALYTICS: any = [];
  const tiktok_ANALYTICS: any = [];
  const pinterest_ANALYTICS: any = [];
  const connectingWords = [
    "and",
    "or",
    "but",
    "if",
    "because",
    "although",
    "since",
    "while",
    "when",
    "after",
    "before",
    "as",
    "that",
    "which",
    "who",
    "whom",
    "whose",
    "where",
    "what",
    "how",
    "the",
    "an",
    "a",
    "in",
    "on",
    "at",
    "with",
    "by",
    "for",
    "of",
    "to",
    "from",
    "through",
    "into",
    "during",
    "within",
    "against",
    "between",
    "among",
    "under",
    "above",
    "below",
    "over",
    "throughout",
    "around",
    "beside",
    "beneath",
    "up",
    "down",
    "off",
    "on",
    "out",
    "over",
    "through",
    "together",
    "apart",
    "forward",
    "backward",
    "away",
    "back",
    "with",
    "without",
    "about",
    "for",
    "against",
    "like",
    "unlike",
    "as",
    "with",
    "without",
    "are",
    "is",
    "do",
    "you",
    "am",
    "I",
  ];
  const THRESHOLD = 0.77;
  const DEFAULT_CONTENT_ORDER = "Time Based";
  const generateDayMappings = () => {
    type DayName = 'Monday' | 'Tuesday' | 'Wednesday' | 'Thursday' | 'Friday' | 'Saturday' | 'Sunday' | 'This Weekend';
    
    const days: Record<DayName, number[]> = {
      'Monday': [1],
      'Tuesday': [2],
      'Wednesday': [3],
      'Thursday': [4],
      'Friday': [5],
      'Saturday': [6],
      'Sunday': [0],
      'This Weekend': [6, 0]
    };

    // Helper function to clean day name without changing order
    const cleanDayName = (str: string): string => {
      return str.trim()
        .replace(/[^a-zA-Z\s]/g, '')
        .replace(/\s+/g, ' ');
    };

    // Helper function to get day numbers including special handling for This Weekend
    const getNumbersFromDays = (dayNames: DayName[]): number[] => {
      // Instead of using Set, we'll concatenate all numbers and sort them
      const numbers: number[] = [];
      dayNames.forEach(day => {
        const dayValues = days[day];
        numbers.push(...dayValues);
      });
      return numbers;
    };

    const mappings: Record<string, number[]> = {};

    // Add single day mappings
    (Object.keys(days) as DayName[]).forEach(day => {
      mappings[day] = days[day];
    });

    // Helper to generate all permutations of an array
    const generatePermutations = (arr: DayName[]): DayName[][] => {
      if (arr.length <= 1) return [arr];
      return arr.reduce((perms: DayName[][], item: DayName, i: number) => {
        const rest = [...arr.slice(0, i), ...arr.slice(i + 1)];
        return perms.concat(
          generatePermutations(rest).map(p => [item, ...p])
        );
      }, []);
    };

    // Generate combinations of 2 days (all permutations)
    (Object.keys(days) as DayName[]).forEach(day1 => {
      (Object.keys(days) as DayName[]).forEach(day2 => {
        if (day1 !== day2) {
          const key = `${day1},${day2}`;
          mappings[key] = getNumbersFromDays([day1, day2]);
        }
      });
    });

    // Generate combinations of 3 days (all permutations)
    (Object.keys(days) as DayName[]).forEach(day1 => {
      (Object.keys(days) as DayName[]).forEach(day2 => {
        (Object.keys(days) as DayName[]).forEach(day3 => {
          if (day1 !== day2 && day2 !== day3 && day1 !== day3) {
            const key = `${day1},${day2},${day3}`;
            mappings[key] = getNumbersFromDays([day1, day2, day3]);
          }
        });
      });
    });

    // Function to get day numbers from any day combination string
    const getDayNumbers = (dayString: string): number[] | undefined => {
      // First try direct lookup
      if (mappings[dayString]) {
        return mappings[dayString];
      }

      // Clean each day name but maintain order
      const parts = dayString.split(',').map(cleanDayName);
      const cleanedString = parts.join(',');
      
      // Try lookup with cleaned string
      if (mappings[cleanedString]) {
        return mappings[cleanedString];
      }

      // If still not found, try to parse the days and generate the numbers
      if (parts.length > 0 && parts.length <= 3) {
        const validDays = parts.filter(part => Object.keys(days).includes(part)) as DayName[];
        if (validDays.length === parts.length) {
          return getNumbersFromDays(validDays);
        }
      }

      return undefined;
    };

    return {
      mappings,
      getDayNumbers
    };
  };

  const dayMappings = generateDayMappings();

  const X_AXIS_STROKE_WIDTH = 2;
  const Y_AXIS_STROKE_WIDTH = 2;
  const LINE_STROKE_WIDTH = 3;
  const SLACK_URL = "https://dev.thesearchbubble.com/slack/update";
  const MAX_COUNT = 25;
  return {
    TITLE,
    BACK_BTN,
    MIN_RANGE,
    AUTH_LOGIN_TEXT,
    AUTH_LOGIN_LINK,
    AUTH_SIGNUP_TEXT,
    AUTH_SIGNUP_LINK,
    AUTH_TERMS_TEXT,
    AUTH_TERMS_LINK,
    AUTH_LOGIN_HEADING,
    AUTH_LOGIN_MSG,
    AUTH_SIGNUP_HEADING,
    AUTH_SIGNUP_MSG,
    ACCOUNT_TITLE,
    PRODUCT_BANK,
    BILLING_TITLE,
    CONTENT_TITLE,
    ANALYTICS_TITLE,
    OVERVIEW_HEADING,
    SEARCH_ORIGINATING_HEADING,
    CONTROLS_TITLE,
    STAGING_CONTROLS_TITLE,
    HOMEPAGE_IMAGES,
    ARCHIVE_FEED_MSG,
    ACTIVE_FEED_MSG,
    SIGNING_UP_TEXTS,
    ROUTELIST_ITEMS,
    SEARCH_EXCEPTIONS,
    instagram_CONTROLS,
    youtube_CONTROLS,
    podcast_CONTROLS,
    tiktok_CONTROLS,
    pinterest_CONTROLS,
    newsletter_CONTROLS,
    instagram_ANALYTICS,
    youtube_ANALYTICS,
    podcast_ANALYTICS,
    tiktok_ANALYTICS,
    pinterest_ANALYTICS,
    newsletter_ANALYTICS,
    MANAGE_ALL_LINKS_TITLE,
    MANAGE_STAYUPTODATE_TITLE,
    MANAGE_LANDING_TITLE,
    TYPES,
    PLATFORMS,
    dayMappings: dayMappings.mappings,
    connectingWords,
    THRESHOLD,
    PLATFORMS_INTEGRATION_TITLE,
    CONTENT_PLATFORMS,
    PRODUCT_PLATFORMS,
    X_AXIS_STROKE_WIDTH,
    Y_AXIS_STROKE_WIDTH,
    LINE_STROKE_WIDTH,
    SLACK_URL,
    TUTORIALS_TITLE,
    DEFAULT_CONTENT_ORDER,
    MAX_COUNT
  };
}
